import React from 'react';
import Image from 'react-bootstrap/Image';

function ActionIcon({ variant = 'view', src, alt = '', onClick, to, as: Component = 'button' }) {
  const className = `hr-action-icon ${variant}`;
  const image = <Image src={src} alt={alt} />;

  if (Component === 'button') {
    return (
      <button type="button" className={className} onClick={onClick}>
        {image}
      </button>
    );
  }

  return (
    <Component className={className} onClick={onClick} to={to} style={{ textDecoration: 'none' }}>
      {image}
    </Component>
  );
}

export default ActionIcon;
